import { remove } from '../../../core/api/dicomApi';

const deleteSeries = async (studyInstanceUid: string, seriesInstanceUid: string): Promise<void> =>
  await remove(`/studies/${studyInstanceUid}/series/${seriesInstanceUid}`);

export default deleteSeries;
